import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { AgregarPromocionModal } from "./AgregarPromocionModal";
import request from "../../../Helpers/API";
import EditIcon from '@mui/icons-material/Edit';
import { EditarPromocionModal } from "./EditarPromocionModal";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import FiltroPromociones from "./FiltroPromociones";
import { useBox } from "../../Finanzas/Helper/useBox";

export const PromocionesListadoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [esquemas, setEsquemas] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [idPromocionSelect, setidPromocionSelect] = useState();
    const [estado, setEstado] = useState(false);
    const [lineaSeleccionada, setLineaSeleccionada] = useState(1);
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(1);
    const [lineasDisponibles, setLineasDisponibles] = useState([]);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleLineaChange = (event) => {
        const idLinea = event.target.value;
        setLineaSeleccionada(idLinea);

        const linea = lineasDisponibles.find(l => l.idlinea === idLinea);
        setDepartamentoSeleccionado(linea ? linea.iddepartamento : null);
    };

    // console.log(departamentoSeleccionado)

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id) => {
        setidPromocionSelect(id);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setidPromocionSelect(null)
        setOpenModalEditar(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        const fetchData = async () => {
            setLoader(prev => ({ ...prev, mostrar: true }));

            try {
                const requests = [
                    request.get(`PromocionesDisponibles/PromocionesDisponibles?estado=${'CC'}`),
                    request.get(`ListadoModelos/LineasDropDownList`)
                ];

                const [result1, result2] = await Promise.all(requests);

                setEsquemas(result1);
                setLineasDisponibles(result2);
            } catch (error) {
                Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
            } finally {
                setLoader(prev => ({ ...prev, mostrar: false }));
            }
        };
        fetchData();
        // request
        //     .get(
        //         `PromocionesDisponibles/PromocionesDisponibles`
        //     )
        //     .then((result) => {
        //         setLoader({ ...loader, mostrar: false });
        //         setEsquemas(result);
        //         return;
        //     })
        //     .catch((error) => {
        //         setLoader({ ...loader, mostrar: false });
        //         return;
        //     });
        // setLoader({ ...loader, mostrar: false });
    }, [openModal, openModalEditar]);
    const onExecute = (estado) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `PromocionesDisponibles/PromocionesDisponibles?estado=${estado}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setEsquemas(result)
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };
    // console.log(esquemas)
    return (
        <PlantillaScreen
            titulo={`LISTA DE PRECIOS`}
            className={"promociones-disponibles-main-screen"}
            className_main={1}
        >
            <div className="promociones-disponibles-actions">
                <div
                    className="promociones-disponibles-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="promociones-disponibles-actions-filtro">
                    <FiltroPromociones
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    />
                </div>
                <div className="buttons">
                    <button className="promociones-disponibles-agregar"
                        onClick={() => handleOpenModal()}
                    >
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>
            </div>
            <div className="promociones-disponibles">
                <LoaderScreen loader={loader} />
                {/* <div className="promociones-disponibles-filtro">
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="linea-select-label">Mostrar Línea</InputLabel>
                        <Select
                            labelId="linea-select-label"
                            value={lineaSeleccionada}
                            label="Filtrar por Línea"
                            onChange={handleLineaChange}
                        >
                            {lineasDisponibles.map((linea, index) => (
                                <MenuItem key={linea.idlinea} value={linea.idlinea}>
                                    {capitalizePalabras(linea.descripcion)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div> */}
                <div className="promociones-disponibles-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Promocion
                                </th>
                                <th>
                                    <div>Inicio Vigencia</div>
                                </th>
                                <th>
                                    <div>Vigencia</div>
                                </th>
                                <th>
                                    <div>Estado</div>
                                </th>
                                <th style={{ color: 'transparent' }}>
                                    <div>.</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {esquemas.map((es) => (
                                <tr key={es.idpromocion}
                                    className={es.estado?.trim().toLowerCase() === "vencido" ? "tr-vencido" : ""}>
                                    <td className={`celda-descripcion ${es.estado?.trim().toLowerCase() === "vencido" ? "td-borde-vencido" : ""}`}>
                                        <div>{es.descripcion_promocion}</div>
                                    </td>
                                    <td className="celda-importe">{es.inicio_vigencia}</td>
                                    <td className="celda-importe">{es.vigencia}</td>
                                    <td className="celda-importe">{es.estado}</td>
                                    <td className="celda-editar">
                                        <div className="promociones-disponibles-acciones-listado">
                                            <div
                                                className="boton-editar"
                                                onClick={() => handleOpenModalEditar(es.idpromocion)}
                                            >
                                                <EditIcon /> Editar
                                            </div>
                                            <div
                                                className="boton-agregar"
                                                onClick={() => history.push("/Ventas/AgregarModeloEsquema", {
                                                    idpromocion: es.idpromocion,
                                                    promocion: es.descripcion_promocion,
                                                    linea: lineaSeleccionada,
                                                    departamento: departamentoSeleccionado
                                                })}
                                            >
                                                <AddCircleOutlineIcon /> Agregar Modelos
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <AgregarPromocionModal
                    open={openModal}
                    onClose={handleCloseModal}
                />
                <EditarPromocionModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    id={idPromocionSelect}
                />
            </div>
        </PlantillaScreen>
    );
};
